import React from 'react';
import Leagues from '../../../shared/Events/Filters/Leagues/Leagues';
import Orders from '../../../shared/Events/Filters/Orders/Orders';
import MainMarkets from '../../../shared/Events/Table/MainMarkets/MainMarkets';

const Filters = () => {
    return (
        <div className={'filter-area'}>
            <div className={'filter-grid'} style={{ width: '30%' }}>
                <Leagues />
            </div>
            <div className={'filter-grid'} style={{ width: '20%' }}>
                <Orders />
            </div>
            <div className={'filter-grid'} style={{ width: '60%', paddingBottom: 0 }}>
                <MainMarkets />
            </div>
        </div>
    );
};

export default Filters;
